import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// eslint-disable-next-line no-undef
console.log("🌍 i18n.ts initializing...", {
  i18nExists: typeof i18n !== "undefined",
  initReactI18nextExists: typeof initReactI18next !== "undefined",
});

// Dodatek obsługuje wyłącznie język polski
// const appLanguage = "pl-PL"; // Reserved for future use

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: {
        translation: {
          splash_title: "CARBOwaste",
          splash_subtitle: "Excel Add-in",
          app_logo_alt: "Logo CARBOwaste",

          // SplashScreen messages
          splash_check_login_again: "Zaloguj się",
          splash_checking_login_status: "Sprawdzanie statusu logowania...",
          splash_checking_status_again: "Sprawdzanie statusu ponownie...",
          splash_last_validation: "Ostatnia walidacja:",
          splash_loading_addon: "Ładowanie dodatku...",
          splash_loading_label: "Ładowanie:",
          splash_logged_as: "Zalogowany jako:",
          splash_login_error: "Błąd logowania",
          splash_login_instructions:
            "Aby korzystać z dodatku, musisz być zalogowany do Excel Online z kontem Microsoft należącym do organizacji.",
          splash_login_instructions_title: "Instrukcje logowania",
          splash_login_via_popup: "Zaloguj przez popup",
          splash_no: "nie",
          splash_not_logged: "Nie zalogowany",
          splash_popup_login_in_progress: "Logowanie w toku...",
          splash_status_label: "Status:",
          splash_unknown_user: "Nieznany użytkownik",
          splash_yes: "tak",

          // Common UI elements
          "common.back": "Powrót",
          "common.cancel": "Anuluj",
          "common.save": "Zapisz",
          "common.close": "Zamknij",
          "common.ok": "OK",

          // App.tsx
          AccordionHeader_header: "Raporty i zestawienia danych BDO",

          AccordionHeader_generated_reports: "Zestawienia wytworzonych odpadów",
          AccordionHeader_generated_reports_description:
            " Zestawienia wytworzonych odpadów, które można wygenerować na podstawie danych z BDO",
          AccordionHeader_generated_reports_option1: "Zestawienie miesięczne",
          AccordionHeader_generated_reports_option1_subtext:
            "Zestawienie odpadów wytworzonych w poszczególnych miesiącach roku (po kodach odpadów)",
          AccordionHeader_generated_reports_option2: "Zestawienie roczne",
          AccordionHeader_generated_reports_option2_subtext:
            "Podsumowanie ilości odpadów wytworzonych w danym roku w odniesieniu do limitów określonych w pozwoleniu na wytwarzanie odpadów.",

          AccordionHeader_control_reports: "Raporty kontrolne KPO i KEO",
          AccordionHeader_control_reports_description:
            "Weryfikacja stanu rejestracji odpadów dla kart KPO i KEO. Walidacja danych w systemie BDO.",
          AccordionHeader_control_reports_option1: "Potwierdzone KPO",
          AccordionHeader_control_reports_option1_subtext:
            "Szczegółowe zestawienie kart przekazania odpadu ze statusem <b>potwierdzenia przejęcia</b> i <b>potwierdzenia transportu</b> wraz z weryfikacją wpisu do karty ewidencji odpadów.",
          AccordionHeader_control_reports_option2: "KEO Roczne",
          AccordionHeader_control_reports_option2_subtext:
            "Podsumowanie kart ewidencji odpadów dla danego roku",
          AccordionHeader_control_reports_option3: "Przegląd statusów KPO",
          AccordionHeader_control_reports_option3_subtext:
            "Zestawienie kart przekazania odpadu z ich aktualnym statusem i datą ostatniej modyfikacji",
          AccordionHeader_control_reports_option4: "Podgląd KPO",
          AccordionHeader_control_reports_option4_subtext:
            "Szczegółowy podgląd KPO z możliwością wydruku.",
          AccordionHeader_control_reports_option5: "Podgląd KEO",
          AccordionHeader_control_reports_option5_subtext:
            "Szczegółowy podgląd KEO z możliwością wydruku.",

          AccordionHeader_dictionary: "Słowniki systemowe BDO",
          AccordionHeader_dictionary_description:
            "Pobieranie słowników systemowych BDO, takich jak katalog odpadów czy procesów odzysku i unieszkodliwiania.",
          AccordionHeader_dictionary_option1: "Katalog odpadów",
          AccordionHeader_dictionary_option1_subtext:
            "Kody odpadów w formie listy z pełną nazwą, określeniem czy niebezpieczne oraz czy kod jest aktualny",
          AccordionHeader_dictionary_option2: "Procesy przetwarzania",
          AccordionHeader_dictionary_option2_subtext:
            "Wykaz procesów przetwarzania odpadów z kodem i pełną nazwą",

          // Footer.tsx
          footer_tooltip_settings: "Konfiguracja miejsc prowadzenia działalności",
          footer_tooltip_info: "Informacje o dodatku",
          footer_network_error: "Brak połączenia z serwerem. Kliknij aby sprawdzić ponownie.",
          footer_network_ok: "Połączenie z serwerem aktywne",

          // Messages
          message_no_default_point_title: "Brak dodanych miejsc prowadzenia działalności (MPD)",
          message_no_default_point_body:
            "Aby móc korzystać z funkcji pobierania danych z BDO, musisz dodać przynajmniej jeden punkt MPD.",
          message_no_default_point_button: "Dodaj miejsca prowadzenia działalności (MPD)",
          message_no_default_point_button_tooltip: "Przejdź do dodawania punktu MPD.",
          message_trial_expired_title: "Brak aktywnej subskrypcji SaaS",
          message_trial_expired_body:
            "Twoja subskrypcja wygasła. Aby kontynuować korzystanie z aplikacji, skontaktuj się z administratorem lub zakup pełną wersję.",

          // Buttons
          button_back: "Powrót",
          button_help: "Pomoc",
          button_add: "Dodaj",

          CollectionPointsPage_title: "Miejsca prowadzenia działalności",
          CollectionPointsPage_description:
            "Lista miejsc prowadzenia działalności zarejestrowanych w BDO.",

          table_WasteCollectionPoint_column0: "Status",
          table_WasteCollectionPoint_status_active: "Aktywny",
          table_WasteCollectionPoint_status_inactive: "Nieaktywny",
          table_WasteCollectionPoint_column1: "Identyfikator i nazwa MPD",

          //CollectionPoinAdd
          CollectionPoinAdd_title: "Dodaj miejsca prowadzenia działalności",
          CollectionPoinAdd_MessageBarTitle: "Dane z BDO",
          CollectionPoinAdd_MessageBar:
            "Szczegółowe informacje jak zarejestrować aplikację i pobrać wymagane dane z BDO dostępne są pod tym linkiem na stronie BDO:",
          CollectionPoinAdd_MessageBarLink: "Instrukcja",
          CollectionPoinAdd_MessageBarLinkUrl:
            "https://bdo.mos.gov.pl/wp-content/uploads/2023/04/BDO_IS_Instrukcja-generowania-kluczy-API.pdf",

          CollectionPoinAdd_form_ClientId: "Client ID (pobrane z BDO)",
          CollectionPoinAdd_form_ClientSecret: "Client Secret (pobrane z BDO)",
          CollectionPoinAdd_form_button_save: "Pobierz dane z BDO i zapisz",
          CollectionPoinAdd_form_button_cancel: "Anuluj",

          GetCollectionPointsFromBdo_success:
            "Miejsca prowadzenia działalności zostały pomyślnie pobrane z BDO i dodane do listy.",

          ReportsControlCard_button_generate: "Generuj raport",
          ReportsControlCard_date_error: "Data 'do' nie może być wcześniejsza niż data 'od'",

          ReportsControlCard_Option1_Radio_Header: "Zakres czasowy raportu",
          ReportsControlCard_Option1_Radio_A: "Obecny miesiąc",
          ReportsControlCard_Option1_Radio_B: "Poprzedni miesiąc",
          ReportsControlCard_Option1_Radio_C: "Wybrany miesiąc i rok",
          ReportsControlCard_Option1_Radio_C_Subtext:
            "Wybierz rok i miesiąc w celu pobrania raportu.",

          ReportsControlCard_Option2_Radio_A: "Aktualny rok",
          ReportsControlCard_Option2_Radio_B: "Poprzedni rok",
          ReportsControlCard_Option2_Radio_C: "Inny rok",

          // Dodaj brakujący klucz dla "retry" z SplashScreen
          retry: "Spróbuj ponownie",

          // Email validation
          email_invalid_format: "Niepoprawny format adresu email. Proszę spróbować ponownie.",

          // First-run experience texts (Polish)
          firstrun_welcome: "Witaj w CARBOwaste",
          firstrun_skip: "Pomiń",
          firstrun_close: "Zamknij",
          firstrun_next: "Dalej",
          firstrun_previous: "Wstecz",
          firstrun_get_started: "Zaczynamy",
          firstrun_end: "Koniec",
          firstrun_dont_show_again: "Nie pokazuj tego intro przy starcie",
          info_page_view_intro: "Zobacz intro",
          info_link_app_description: "Opis aplikacji",
          info_link_privacy_policy_short: "Polityka prywatności",
          info_link_terms_of_use_short: "Warunki użytkowania",
          firstrun_click_to_enlarge: "Kliknij aby powiększyć",
          firstrun_slide0_title: "CARBOwaste Excel Add-in",
          firstrun_slide0_description:
            "Kompleksowe rozwiązanie do zarządzania odpadami zintegrowane bezpośrednio z Microsoft Excel dla płynnej obsługi danych i raportowania.",
          firstrun_slide1_title: "Monitoruj karty KPO",
          firstrun_slide1_description:
            "Twórz zestawienia Kart Przekazania Odpadu z ich aktualnym statusem. Wykrywaj ewentualne błędy w wystawionych KPO.",
          firstrun_slide2_title: "Twórz raporty dla KPO i KEO",
          firstrun_slide2_description:
            "Generuj raporty dotyczące KPO, ze statusem potwierdzenia przejęcia i/lub potwierdzenia transportu. Zweryfikuj poprawność KEO dla danego kodu odpadu.",
          firstrun_slide3_title: "Generuj roczny raport KEO",
          firstrun_slide3_description:
            "Jednym kliknięciem wygeneruj podsumowanie kart ewidencji odpadów dla danego roku.",
          firstrun_slide4_title: "Twórz zestawienia wytworzonych odpadów - miesięczne",
          firstrun_slide4_description:
            "Twórz zestawienia odpadów wytworzonych w poszczególnych miesiącach roku.",
          firstrun_slide5_title: "… oraz w skali całego roku",
          firstrun_slide5_description:
            "W ciągu kilku sekund uzyskaj podsumowanie ilości odpadów wytworzonych w danym roku w odniesieniu do limitów określonych w pozwoleniu na wytwarzanie odpadów.",


          // KPO caerd report page
          "kpoCard_report.card_label": "Numer karty KPO",
          "kpoCard_report.card_placeholder": "Wpisz numer karty KPO",
          "kpoCard_report.card_invalid": "Niepoprawny numer karty KPO",
          "kpoCard_report.card_format_info": "Poprawny format: XXXXX/YYYY/KPO/XXXX/XXXXXXXXX. Gdzie X to cyfry, a Y to rok.",
          "kpoCard_report.generate_button": "Generuj podgląd karty KPO",
          "kpoCard_report.card_pointid_mismatch": "Numer punktu w karcie KPO nie zgadza się z numerem identyfikacyjnym wybranego MPD",

          // KEO card report page
          "keoCard_report.card_label": "Numer karty KEO",
          "keoCard_report.card_placeholder": "Wpisz numer karty KEO",
          "keoCard_report.card_invalid": "Niepoprawny numer karty KEO",
          "keoCard_report.card_format_info": "Poprawny format: XXXXX/YYYY/KEO/XXXX/XXXXXXXXX. Gdzie X to cyfry, a Y to rok.",
          "keoCard_report.generate_button": "Generuj podgląd karty KEO",
          "keoCard_report.card_pointid_mismatch": "Numer punktu w karcie KEO nie zgadza się z numerem identyfikacyjnym wybranego MPD",

          // Help links (Polish)
          help_link_first_run_experience: "Przewodnik po funkcjach",

          // Subscription texts (Polish)
          "subscription.accessDenied.title": "Funkcja niedostępna",
          "subscription.accessDenied.description":
            "Aby uzyskać dostęp do tej funkcji, potrzebujesz wyższego planu subskrypcji.",
          "subscription.currentPlan": "Obecny plan",
          "subscription.freeTrial": "Wersja próbna",
          "subscription.upgrade": "Ulepsz plan",
          "subscription.refresh": "Odśwież",
          "subscription.dashboard.title": "Status subskrypcji",
          "subscription.dashboard.loading": "Ładowanie informacji o subskrypcji...",
          "subscription.dashboard.loadingDetails": "Sprawdzanie statusu subskrypcji",
          "subscription.dashboard.refreshError": "Błąd podczas odświeżania:",
          "subscription.dashboard.currentPlan": "Obecny plan",
          "subscription.dashboard.trialExpiry": "Wersja próbna wygasa",
          "subscription.dashboard.subscriptionExpiry": "Brak aktywnej subskrypcji SaaS",
          "subscription.dashboard.availableFeatures": "Dostępne funkcje",
          "subscription.dashboard.noFeatures": "Brak dostępnych funkcji",
          "subscription.dashboard.upgrade": "Ulepsz plan",
          "subscription.dashboard.refresh": "Odśwież",
          "subscription.dashboard.refreshing": "Odświeżanie...",
          "subscription.dashboard.suspended_info":
            "💡 Przywrócenie subskrypcji nastąpi automatycznie po rozwiązaniu problemów z płatnością.",
          "subscription.status.active": "Aktywna",
          "subscription.status.activeDesc": "Subskrypcja jest aktywna i w pełni funkcjonalna.",
          "subscription.status.inactive": "Nieaktywna",
          "subscription.status.inactiveDesc": "Brak aktywnej subskrypcji.",
          "subscription.status.cancelled": "Anulowana",
          "subscription.status.cancelledDesc": "Subskrypcja została anulowana.",
          "subscription.status.suspended": "Zawieszona",
          "subscription.status.suspendedDesc":
            "Subskrypcja została tymczasowo zawieszona.",
          "subscription.status.freeTrial": "Wersja próbna",
          "subscription.status.freeTrialDesc": "Korzystasz z bezpłatnej wersji próbnej.",
          "subscription.status.pendingActivation": "Oczekuje na aktywację",
          "subscription.status.pendingActivationDesc":
            "Subskrypcja oczekuje na aktywację.",
          "subscription.status.label": "Status subskrypcji",
          "subscription.title": "Subskrypcja",
          "subscription.details": "Szczegóły subskrypcji",
          "subscription.user": "Użytkownik",
          "subscription.user_email": "Email",
          "subscription.user_unknown": "Nieznany",
          "subscription.purchaser": "Nabywca subskrypcji",
          "subscription.plan": "Plan",
          "subscription.start_date": "Data rozpoczęcia",
          "subscription.end_date": "Data zakończenia",
          "subscription.companies_count": "Liczba podmiotów BDO / Limit subskrypcji",
          "subscription.eups_count": "Liczba MPD / Limit subskrypcji",
          "subscription.device_id": "ID urządzenia",
          "subscription.companies": "Firmy",
          "subscription.unlimited": "Bez limitu",
          "subscription.no_data": "Brak danych subskrypcji",
          "subscription.no_data_desc": "Nie można pobrać informacji o subskrypcji.",
          "subscription.trial_mode_enabled": "Dostęp w trybie testowym",
          "subscription.limited_access": "Ograniczony dostęp do funkcjonalności",
          "subscription.activate_app": "Aktywuj aplikację",
          "subscription.buy_subscription": "Kup subskrypcję",
          "subscription.activation_dialog.title": "Aktywacja aplikacji",
          "subscription.activation_dialog.description": "Wprowadź klucz aktywacyjny otrzymany od administratora lub z zakupu subskrypcji.",
          "subscription.activation_dialog.activation_key_label": "Klucz aktywacyjny",
          "subscription.activation_dialog.activation_key_placeholder": "Wprowadź klucz aktywacyjny",
          "subscription.activation_dialog.activate_button": "Aktywuj",
          "subscription.activation_dialog.cancel_button": "Anuluj",
          "subscription.activation_dialog.activating": "Aktywowanie...",
          "subscription.activation_dialog.success": "Aplikacja została pomyślnie aktywowana!",
          "subscription.activation_dialog.error": "Błąd aktywacji",
          "subscription.activation_dialog.key_required": "Klucz aktywacyjny jest wymagany",
          "subscription.view_companies": "Zobacz listę podmiotów BDO i MPD",
          "subscription.add_activation_key": "Dodaj nowy klucz",
          "subscription.unregister": "Odinstaluj klucz",

          // Activation Page
          "activation.title": "Aktywacja aplikacji",
          "activation.toolbar.back": "Powrót",
          "activation.toolbar.back_tooltip": "Powrót do poprzedniej strony",
          "activation.description": "Wprowadź klucz aktywacyjny otrzymany od administratora lub z zakupu subskrypcji.",
          "activation.key_label": "Klucz aktywacyjny",
          "activation.key_placeholder": "Wklej klucz subskrypcji (maks. 256 znaków)",
          "activation.key_length": "Długość",
          "activation.key_characters": "znaków",
          "activation.button.activate": "Aktywuj",
          "activation.button.activating": "Aktywowanie...",
          "activation.hint": "Możesz także nacisnąć Ctrl+Enter aby aktywować",
          "activation.success.title": "Aktywacja pomyślna!",
          "activation.success.message": "Aplikacja została pomyślnie aktywowana. Przekierowywanie...",
          "activation.error.title": "Błąd aktywacji",
          "activation.error.key_required": "Klucz aktywacyjny jest wymagany",
          "activation.error.unknown": "Nieznany błąd aktywacji",
          "activation.error.http": "Błąd HTTP",

          // Unregister Page
          "unregister.title": "Odinstalowanie klucza aktywacyjnego",
          "unregister.toolbar.back": "Powrót",
          "unregister.toolbar.back_tooltip": "Powrót do poprzedniej strony",
          "unregister.warning.critical": "UWAGA: Ta operacja spowoduje usunięcie wszystkich danych!",
          "unregister.warning.what_deleted": "Co zostanie usunięte?",
          "unregister.warning.item1": "Powiązanie tej instancji aplikacji z Twoją subskrypcją",
          "unregister.warning.item2": "Wszystkie dodane firmy i ich dane dostępowe (Client ID i Client Secret)",
          "unregister.warning.item3": "Lista przypisanych EUP (Miejsc Prowadzenia Działalności)",
          "unregister.warning.item4": "Wszystkie lokalne ustawienia i konfiguracje",
          "unregister.info.after_unregister": "Po odinstalowaniu klucza:",
          "unregister.info.trial_mode": "Aplikacja przejdzie w tryb TRIAL (próbny). Aby ponownie korzystać z pełnej wersji, będziesz musiał/a wprowadzić nowy klucz aktywacyjny.",
          "unregister.confirmation.checkbox": "Potwierdzam, że rozumiem konsekwencje tej operacji i chcę odinstalować klucz aktywacyjny z tej instancji aplikacji.",
          "unregister.button.cancel": "Anuluj",
          "unregister.button.unregister": "Odinstaluj klucz",
          "unregister.button.unregistering": "Odinstalowywanie...",
          "unregister.success.title": "Odinstalowanie pomyślne!",
          "unregister.success.message": "Klucz został odinstalowany. Aplikacja przeszła w tryb TRIAL. Przekierowywanie...",
          "unregister.error.title": "Błąd odinstalowania",
          "unregister.error.confirm_required": "Musisz potwierdzić operację",
          "unregister.error.unknown": "Nieznany błąd odinstalowania",
          "unregister.error.http": "Błąd HTTP",

          // BDO Entities Page
          "bdo_entities.title": "Podmioty BDO",
          "bdo_entities.no_companies": "Brak firm w subskrypcji",
          "bdo_entities.eup_count": "Liczba EUP",
          "bdo_entities.column.name": "Podmiot BDO",
          "bdo_entities.column.eup_name": "Nazwa EUP",
          "bdo_entities.column.status": "Status",
          "bdo_entities.status.active": "Aktywny",
          "bdo_entities.status.inactive": "Nieaktywny",
          "bdo_entities.toolbar.add": "Dodaj",
          "bdo_entities.toolbar.update": "Aktualizuj",
          "bdo_entities.toolbar.delete": "Usuń",

          // Add Company Page
          "add_company.title": "Dodaj firmę z BDO",
          "add_company.toolbar.back": "Powrót",
          "add_company.toolbar.back_tooltip": "Powrót do poprzedniej strony",
          "add_company.info.title": "Informacja",
          "add_company.info.description": "Aby dodać firmę do subskrypcji, potrzebujesz kluczy API z systemu BDO z ",
          "add_company.info.instructions_link": "oficjalnej instrukcji BDO",
          "add_company.client_id_label": "Client ID",
          "add_company.client_id_placeholder": "Wprowadź Client ID z BDO",
          "add_company.client_id_hint": "Format: 8-4-4-4-12 znaków hex (np. 0f5ce8d2-1d97-43cd-a0f4-4dc7f82ef115)",
          "add_company.client_secret_label": "Client Secret",
          "add_company.client_secret_placeholder": "Wprowadź Client Secret z BDO",
          "add_company.client_secret_hint": "Format: 64 znaki hex (np. 48115dc6...e39066)",
          "add_company.button.cancel": "Anuluj",
          "add_company.button.add": "Dodaj firmę",
          "add_company.button.adding": "Dodawanie...",
          "add_company.success.title": "Firma dodana pomyślnie!",
          "add_company.success.message": "Firma została pomyślnie dodana. Przekierowywanie...",
          "add_company.error.title": "Błąd dodawania firmy",
          "add_company.error.fields_required": "Wszystkie pola są wymagane",
          "add_company.error.invalid_client_id": "Client ID musi mieć format UUID (np. 0f5ce8d2-1d97-43cd-a0f4-4dc7f82ef115)",
          "add_company.error.invalid_client_secret": "Client Secret musi mieć 64 znaki.",
          "add_company.error.unknown": "Nieznany błąd dodawania firmy",
          "add_company.error.http": "Błąd HTTP",

          // Delete Company Page
          "delete_company.title": "Usuwanie firmy z subskrypcji",
          "delete_company.toolbar.back": "Powrót",
          "delete_company.toolbar.back_tooltip": "Powrót do poprzedniej strony",
          "delete_company.company_label": "Firma",
          "delete_company.warning.important": "Ważna informacja",
          "delete_company.warning.description": "Ta operacja usunie firmę wraz ze wszystkimi powiązanymi danymi z Twojej subskrypcji.",
          "delete_company.warning.critical": "UWAGA: Po usunięciu firmy nie będzie możliwe jej ponowne dodanie przez 365 dni od dnia usunięcia.",
          "delete_company.confirmation.checkbox": "Rozumiem konsekwencje i chcę trwale usunąć tę firmę z subskrypcji. Jestem świadomy/a, że nie będę mógł/mogła dodać jej ponownie przez 365 dni.",
          "delete_company.button.cancel": "Anuluj",
          "delete_company.button.delete": "Usuń firmę",
          "delete_company.button.deleting": "Usuwanie...",
          "delete_company.success.title": "Firma usunięta pomyślnie!",
          "delete_company.success.message": "Firma została usunięta z subskrypcji. Przekierowywanie...",
          "delete_company.error.title": "Błąd usuwania firmy",
          "delete_company.error.confirm_required": "Musisz potwierdzić operację",
          "delete_company.error.unknown": "Nieznany błąd usuwania firmy",
          "delete_company.error.http": "Błąd HTTP",

          // Add Company Dialog (deprecated - kept for backward compatibility)
          "add_company.dialog.title": "Dodaj firmę BDO",
          "add_company.dialog.description": "Aby dodać firmę do subskrypcji, potrzebujesz kluczy API z systemu BDO.",
          "add_company.dialog.instructions_link": "oficjalnej instrukcji BDO",
          "add_company.dialog.client_id_label": "Client ID",
          "add_company.dialog.client_secret_label": "Client Secret",
          "add_company.dialog.submit": "Dodaj firmę",
          "add_company.dialog.cancel": "Anuluj",
          "add_company.dialog.adding": "Dodawanie firmy...",
          "add_company.dialog.success": "Firma została pomyślnie dodana do subskrypcji!",
          "add_company.dialog.error": "Błąd podczas dodawania firmy",
          "add_company.dialog.required_fields": "Wszystkie pola są wymagane",
          "add_company.dialog.no_fingerprint": "Brak identyfikatora urządzenia. Odśwież aplikację.",
          "add_company.dialog.network_error": "Błąd połączenia z serwerem. Sprawdź połączenie internetowe.",

          // Feature names (Polish)
          "features.basic-import": "Podstawowy import danych",
          "features.advanced-reports": "Zaawansowane raporty",
          "features.bulk-operations": "Operacje masowe",
          "features.custom-templates": "Niestandardowe szablony",
          "features.api-integration": "Integracja API",
          "features.unlimited-data": "Nieograniczone dane",
          "features.priority-support": "Wsparcie priorytetowe",
          "features.white-labeling": "Personalizacja marki",

          // Login/Authentication texts
          login: "Zaloguj się",
          login_microsoft_365: "Zaloguj się do Microsoft 365",
          login_in_progress: "Logowanie...",

          // Authentication status
          auth_authenticated: "Zalogowany",
          auth_unauthenticated: "Wylogowany",
          auth_error: "Błąd",
          auth_checking: "Sprawdzanie...",

          // Connection status
          connection_online: "Online",
          connection_offline: "Offline",

          // ConnectionStatusBar texts
          connection_status_label: "Status połączenia:",
          auth_logged_as: "Zalogowany jako:",
          auth_unknown_user: "Nieznany",
          auth_last_verification: "Ostatnia weryfikacja:",
          auth_not_logged_office365: "Nie zalogowany do Office 365",
          auth_error_label: "Błąd uwierzytelnienia:",
          auth_unknown_error: "Nieznany błąd",
          auth_checking_status: "Sprawdzanie statusu uwierzytelnienia...",

          // Device and Subscription messages
          "device.initializing": "Inicjalizacja urządzenia...",
          "device.not_registered": "Urządzenie nie jest zarejestrowane w systemie",
          "device.registration_required": "Aby móc korzystać z aplikacji, urządzenie musi być zarejestrowane.",
          "device.fingerprint_generated": "Wygenerowano identyfikator urządzenia",
          "device.subscription_loading": "Sprawdzanie subskrypcji...",
          "device.subscription_loaded": "Subskrypcja załadowana pomyślnie",
          "device.subscription_expired": "Subskrypcja wygasła",
          "device.subscription_active": "Subskrypcja aktywna do {{date}}",
          "device.company_loaded": "Załadowano dane firmy: {{name}}",
          "device.eup_count": "Liczba punktów EUP: {{count}}",
          "device.error_initialization": "Błąd inicjalizacji urządzenia",
          "device.error_fingerprint": "Błąd generowania identyfikatora urządzenia",
          "device.error_subscription_fetch": "Błąd pobierania danych subskrypcji",
          "device.connection_error_title": "Błąd połączenia",
          "device.connection_error_message": "Wystąpił błąd połączenia sieciowego z usługami.",
          "device.trial_mode_fallback": "Aplikacja będzie działać w wersji próbnej.",
          "device.retry_connection": "Spróbuj ponownie",
          "device.retrying_connection": "Wznawianie...",
          "device.retrying_connection_title": "Wznawianie połączenia sieciowego...",
          "device.network_error_message": "Wystąpił problem z połączeniem do serwera usług podczas inicjalizacji urządzenia.",
          "device.error_details": "Szczegóły błędu:",
          "device.trial_mode_info": "Aplikacja będzie działać w trybie próbnym z ograniczoną funkcjonalnością.",
          "device.trial_mode": "Aplikacja działa w trybie TRIAL (nieograniczony czas)",
          "device.trial_unlimited": "Wersja próbna bez ograniczeń czasowych",
          "device.trial_simple": "Aplikacja w wersji próbnej",
          "device.subscription_suspended_trial": "Subskrypcja zawieszona - dostęp w trybie testowym",
          "device.subscription_cancelled_trial": "Subskrypcja anulowana - dostęp w trybie testowym",
          "device.subscription_suspended": "Subskrypcja zawieszona - ograniczona funkcjonalność",
          "device.subscription_cancelled": "Subskrypcja anulowana - ograniczona funkcjonalność",

          // App.tsx error messages
          app_must_be_logged: "❌ Musisz być zalogowany do Excel aby korzystać z aplikacji",
          app_cannot_get_email:
            "❌ Nie można pobrać adresu email z Excel. Upewnij się, że jesteś zalogowany do Microsoft 365.",
          app_loading_collection_points: "Ładowanie punktów padzenia działalności...",
          app_loading_waste_processes: "Pobieranie danych procesów odpadów...",
          app_waste_processes_success: "Dane procesów odpadów pobrane pomyślnie!",
          app_loading_waste_codes: "Pobieranie kodów odpadów...",
          app_waste_codes_success: "Kody odpadów pobrane pomyślnie!",

          // CarboWasteApi error messages
          // API errors
          CW400: "Nieprawidłowe żądanie",
          CW401: "Brak autoryzacji",
          CW403: "Dostęp zabroniony",
          CW404: "Nie znaleziono",

          // Registration errors (CW5xx)
          CW500: "Nieokreślony błąd. Skontaktuj się z administratorem systemu na adres support@carbomath.com",

          CW501: "Nieprawidłowe dane żądania",
          CW502: "Identyfikator urządzenia jest wymagany",
          CW503: "Platforma jest wymagana",
          CW504: "Host jest wymagany",
          CW505: "UserAgent jest wymagany",
          CW506: "Klucz aktywacyjny jest wymagany",
          CW507: "Nieprawidłowy lub wygasły klucz aktywacyjny",
          CW508: "Nie znaleziono subskrypcji dla podanego klucza aktywacyjnego",
          CW509: "Wystąpił błąd podczas rejestracji metadanych urządzenia",
          CW510: "Wystąpił błąd podczas dodawania firmy do subskrypcji",
          CW511: "Nie udało się dodać firmy do bazy danych",

          // BDO Integration errors (BDO4xx)
          BDO400: "Błąd integracji z BDO",
          BDO401: "Nie udało się uwierzytelnić z API BDO",
          BDO402: "Nie znaleziono EUP w systemie BDO",
          BDO403: "Nie znaleziono firmy w systemie BDO",
          BDO404: "Żądanie API BDO nie powiodło się",

          api_error_fetch_user: "CW01: Błąd pobierania danych użytkownika",
          api_error_create_user: "CW02: Błąd tworzenia nowego użytkownika",
          api_error_connection_local:
            "CW03: Nie można połączyć się z lokalnym serwerem. Sprawdź czy backend działa na porcie 5200",
          api_error_connection_azure:
            "CW04: Nie można połączyć się z Azure API Management. Sprawdź połączenie internetowe",
          api_error_timeout_local: "CW05: Timeout lokalnego serwera. Backend nie odpowiada",
          api_error_timeout_azure:
            "CW06: Timeout Azure API Management. Sprawdź połączenie internetowe",
          api_error_network: "CW07: Wystąpił błąd sieci",
          api_error_unknown: "CW08: Wystąpił nieznany błąd",
          api_error_waste_process: "CW09: Błąd pobierania danych procesów odpadów",
          api_error_waste_code: "CW10: Błąd pobierania kodów odpadów",
          api_error_all_waste_code: "CW11: Błąd pobierania wszystkich kodów odpadów",
          api_warning_pagination_limit:
            "CW12: Osiągnięto maksymalny limit stron (100), zatrzymanie pobierania danych",

          // BDO API errors
          bdo_error_token_fetch: "BDO01: Błąd pobierania tokenu uwierzytelniającego",
          bdo_error_invalid_credentials:
            "BDO02: Podane dane uwierzytelniające są nieprawidłowe lub wygasłe",
          bdo_error_eupids_fetch: "BDO03: Błąd pobierania danych EupIDs z BDO",
          bdo_error_eupids_not_found: "BDO04: Nie znaleziono danych EupIDs w odpowiedzi BDO",
          bdo_error_eupids_empty:
            "BDO05: Nie znaleziono identyfikatora dla podanego numeru identyfikacyjnego",
          bdo_error_eupids_inactive: "BDO06: Znaleziony identyfikator EupId jest nieaktywny",
          bdo_error_connection: "BDO07: Błąd połączenia z API BDO",
          bdo_error_kpo_fetch: "BDO08: Błąd pobierania danych KPO z BDO",
          bdo_error_kpo_printing: "BDO09: Błąd pobierania szczegółowych danych karty KPO",
          bdo_error_keo_fetch: "BDO10: Błąd pobierania danych KEO z BDO",
          bdo_error_keo_generated: "BDO11: Błąd pobierania danych KEO Generated",
          bdo_error_keo_treated: "BDO12: Błąd pobierania danych KEO Treated",
          bdo_error_keo_forwarded: "BDO13: Błąd pobierania danych KEO Forwarded",

          // ProgressPage komponenty
          progress_loading_default: "Pobieranie danych z systemu BDO.",
          progress_success_default: "Dane pobrane pomyślnie!",
          progress_error_default: "Wystąpił nieoczekiwany błąd",
          progress_continue_operation: "Kontynuowanie operacji...",
          progress_confirmation_title: "Potwierdzenie",
          progress_fetching_waste_codes: "Pobieranie słownika kodów odpadów...",
          progress_waste_codes_success: "Słownik kodów odpadów został pobrany",
          progress_fetching_waste_processes: "Pobieranie słownika procesów odzysku...",
          progress_waste_processes_success: "Słownik procesów odzysku został pobrany",

          // InfoPage
          info_page_title: "Pomoc i informacje",
          info_page_help_link: "Pomoc",
          info_page_important_info: "Ważne informacje:",
          info_page_privacy_policy: "Polityka prywatności",
          info_dialog_link_copied_title: "Link skopiowany do schowka",
          info_dialog_excel_web_message:
            "Excel Web nie pozwala na otwieranie zewnętrznych linków. URL został skopiowany do schowka:",
          info_dialog_paste_instruction:
            "Wklej ten link w nowej karcie przeglądarki, aby otworzyć stronę.",

          // Contact Form
          contact_form_title: "Formularz kontaktowy",
          contact_form_description:
            "Wypełnij formularz poniżej, aby skontaktować się z naszym zespołem wsparcia technicznego.",
          "contact_form.toolbar.back": "Powrót",
          "contact_form.toolbar.back_tooltip": "Powrót do poprzedniej strony",
          contact_field_subject: "Temat",
          contact_field_message: "Wiadomość",
          contact_subject_placeholder: "Wybierz temat wiadomości",
          contact_message_placeholder: "Opisz szczegółowo problem lub zadaj pytanie...",
          contact_button_send: "Wyślij wiadomość",
          contact_button_sending: "Wysyłanie...",
          contact_button_cancel: "Anuluj",
          contact_success_message: "Wiadomość została wysłana pomyślnie!",
          contact_success_redirect:
            "Za chwilę zostaniesz przekierowany z powrotem do strony informacji.",
          contact_redirecting: "Przekierowywanie...",
          contact_error_send_failed: "Nie udało się wysłać wiadomości. Spróbuj ponownie.",
          contact_error_user_info_missing: "Brak informacji o użytkowniku. Zaloguj się ponownie.",
          contact_error_required_fields: "Wypełnij wszystkie wymagane pola.",
          contact_user_info_note:
            "Wiadomość zostanie wysłana z Twojego konta: {{name}} ({{email}})",
          contact_unknown_user: "Nieznany użytkownik",
          contact_unknown_email: "Nieznany adres email",
          contact_page_link: "Skontaktuj się z nami",
          info_page_contact_description:
            "Masz pytania lub potrzebujesz pomocy? Skorzystaj z formularza kontaktowego, aby skontaktować się z naszym zespołem wsparcia technicznego w sprawie problemów, sugestii lub pytań dotyczących aplikacji.",
          contact_subject_technical_issue: "Problem techniczny",
          contact_subject_feature_request: "Prośba o nową funkcję",
          contact_subject_bug_report: "Zgłoszenie błędu",
          contact_subject_general_question: "Pytanie ogólne",
          contact_subject_data_issue: "Problem z danymi",
          contact_subject_performance_issue: "Problem z wydajnością",
          contact_subject_user_interface: "Problem z interfejsem",
          contact_subject_documentation: "Problem z dokumentacją",
          contact_subject_other: "Inne",

          // Formularze - placeholder dla MPD
          form_placeholder_select_mpd: "Wybierz MPD (miejsce prowadzenia działalności)",

          // Komunikaty błędów dla raportów
          report_error_no_auth_data:
            "Nie znaleziono danych uwierzytelniających dla wybranego punktu",
          report_error_fetch_bdo_data: "Błąd pobierania danych z BDO",
          report_error_invalid_year: "Nieprawidłowy rok",
          report_error_invalid_parameters: "Nieprawidłowe parametry dla generowania raportu",
          report_success_data_fetched: "Dane do raportu pobrane pomyślnie!",

          // GetCollectionPointsFromBdo błędy
          bdo_error_missing_credentials:
            "BDO00: Brak wymaganych danych uwierzytelniających (clientId lub clientSecret)",

          // Dodatkowe komunikaty błędów i teksty
          form_error_select_point_and_range:
            "Wybierz MPD (miejsce prowadzenia działalności) i zakres czasowy",
          form_error_select_year_for_option_c: "Wybierz rok dla opcji C",
          report_loading_generating_report: "Generowanie raportu zestawienia...",
          report_loading_generating_keo: "Generowanie raportu...",
          report_success_keo_generated: "Raport wygenerowany pomyślnie!",
          report_success_kpo_generated: "Raport wygenerowany pomyślnie!",

          // Status punktów odbioru
          collection_point_status_active: "Aktywny",
          collection_point_status_inactive: "Nieaktywny",

          // Formularze - etykiety i placeholdery
          form_label_month: "Miesiąc",
          form_placeholder_select_month: "Wybierz miesiąc",
          form_placeholder_select_year: "Wybierz rok",
          form_option_all_months: "Wszystkie miesiące",

          // Nazwy miesięcy
          month_january: "Styczeń",
          month_february: "Luty",
          month_march: "Marzec",
          month_april: "Kwiecień",
          month_may: "Maj",
          month_june: "Czerwiec",
          month_july: "Lipiec",
          month_august: "Sierpień",
          month_september: "Wrzesień",
          month_october: "Październik",
          month_november: "Listopad",
          month_december: "Grudzień",

          // InfoPage - jak rozpocząć pracę z dodatkiem
          help_link_how_to_start_free: "Jak rozpocząć pracę z bezpłatną wersją dodatku?",
          help_link_how_to_subscribe: "Jak przejść na pełną wersję dodatku?",
          help_link_how_to_start_paid: "Jak rozpocząć pracę z płatną wersją dodatku?",
          help_link_bdo_credentials: "Jak uzyskać dane uwierzytelniające API z BDO?",

          // InfoPage - help links
          help_links_title: "Szybkie linki do pomocy:",
          help_link_kpo_status_overview: "Przegląd statusów KPO",
          help_link_kpo_confirmed: "Potwierdzone KPO",
          help_link_keo_annually: "KEO Roczne",
          help_link_kpo_view: "Podgląd KPO",
          help_link_keo_view: "Podgląd KEO",
          help_link_monthly_statement: "Zestawienie miesięczne",
          help_link_annual_report: "Zestawienie roczne",
          help_link_waste_catalog: "Katalog odpadów",
          help_link_waste_processes: "Lista procesów przetwarzania",
          help_link_privacy_policy: "Polityka prywatności",
          help_link_terms_of_use: "Warunki korzystania z usługi",

          // Footer subscription messages
          "footer.trial.status": "Wersja próbna",
          "footer.trial.daysLeft": "Zostało {{days}} dni",
          "footer.subscription.expired": "Subskrypcja wygasła",

          // ConnectionStatusBar texts - dodatkowe
          "connection.status.unknown": "Nieznany",
          "connection.status.active": "Aktywna",
          "connection.status.trial": "Okres próbny",
          "connection.status.free": "Darmowa",
          "connection.user_info.title": "Informacje o koncie",
          "connection.user_data.title": "Dane użytkownika",
          "connection.user_data.logged_in": "Zalogowany",
          "connection.user_data.logged_out": "Niezalogowany",
          "connection.user_data.login_status": "Status logowania",
          "connection.user_data.user": "Użytkownik",
          "connection.user_data.email": "Email",
          "connection.user_data.no_data": "Brak",
          "connection.subscription.title": "Subskrypcja",
          "connection.subscription.status": "Status",
          "connection.subscription.plan": "Plan",
          "connection.subscription.expiry_date": "Data wygaśnięcia",
          "connection.subscription.days_remaining": "Dni do końca",
          "connection.subscription.no_expiry_data": "Brak danych",
          "connection.subscription.expired": "Czas subskrypcji upłynął",
          "connection.subscription.expires_on": "Czas subskrypcji upłynie {{date}}",
          "connection.subscription.manage": "Zarządzaj subskrypcją",
          "connection.subscription.refresh_status": "Odśwież status",
          "connection.subscription.refresh_success": "✅ Subskrypcja odświeżona pomyślnie",
          "connection.subscription.refresh_error": "❌ Błąd podczas odświeżania subskrypcji:",
          "connection.dialog.close": "Zamknij",

          // SubscriptionDashboard texts - dodatkowe
          "subscription.dashboard.manage_title": "Zarządzanie subskrypcji",
          "subscription.dashboard.status_title": "Status subskrypcji",
          "subscription.dashboard.status_label": "Status",
          "subscription.cancel.danger_zone": "⚠️ Strefa niebezpieczna",
          "subscription.cancel.warning_description":
            "Anulowanie subskrypcji jest działaniem nieodwracalnym. Po anulowaniu utracisz dostęp do całej aplikacji CARBOwaste.",
          "subscription.cancel.button": "Anuluj subskrypcję",
          "subscription.cancel.dialog_title": "Potwierdzenie anulowania subskrypcji",
          "subscription.cancel.dialog_warning":
            "Czy na pewno chcesz anulować subskrypcję CARBOwaste? Ta akcja jest <strong>nieodwracalna</strong>.",
          "subscription.cancel.consequences_title": "Konsekwencje anulowania:",
          "subscription.cancel.consequence_total_loss":
            "Całkowita utrata dostępu do aplikacji CARBOwaste",
          "subscription.cancel.consequence_no_functions":
            "Brak możliwości korzystania z żadnych funkcji aplikacji",
          "subscription.cancel.consequence_no_reports":
            "Utrata dostępu do wszystkich raportów i analiz",
          "subscription.cancel.consequence_no_support": "Utrata dostępu do wsparcia technicznego",
          "subscription.cancel.consequence_processing_time":
            "Anulowanie zostanie przetworzone przez Microsoft w ciągu 24-48 godzin",
          "subscription.cancel.contact_support":
            "Jeśli masz problemy z aplikacją, skontaktuj się z naszym wsparciem przed anulowaniem subskrypcji.",
          "subscription.cancel.confirm_button": "Tak, anuluj subskrypcję",
          "subscription.cancel.confirm_button_processing": "Anulowanie...",
          "subscription.dashboard.activate": "Aktywuj subskrypcję",
          "subscription.dashboard.renew": "Odnów subskrypcję",
          "subscription.alert.no_subscription_id_activate":
            "Brak identyfikatora subskrypcji. Nie można aktywować subskrypcji.",
          "subscription.alert.no_subscription_id_cancel":
            "Brak identyfikatora subskrypcji. Nie można anulować subskrypcji.",
          "subscription.alert.activation_success": "Subskrypcja została pomyślnie aktywowana.",
          "subscription.alert.suspend_managed_by_microsoft":
            "Zawieszenie subskrypcji jest zarządzane przez Microsoft w przypadku problemów z płatnością. Publisher nie może bezpośrednio zawiesić subskrypcji.",
          "subscription.alert.restore_managed_by_microsoft":
            "Przywrócenie subskrypcji jest zarządzane przez Microsoft po rozwiązaniu problemów z płatnością. Publisher nie może bezpośrednio przywrócić subskrypcji.",
          "subscription.error.unknown": "Nieznany błąd",
          "subscription.error.activation": "Błąd aktywacji subskrypcji",
          "subscription.error.cancellation": "Błąd anulowania subskrypcji",
          "subscription.actions.cancelling": "Anulowanie...",
          "subscription.dialog.cancel.confirm_action": "Tak, anuluj subskrypcję",
          "subscription.dialog.cancel.title": "Potwierdzenie anulowania subskrypcji",
          "subscription.dialog.cancel.warning":
            "Czy na pewno chcesz anulować subskrypcję CARBOwaste? Ta akcja jest <strong>nieodwracalna</strong>.",
          "subscription.dialog.cancel.consequences.title": "Konsekwencje anulowania:",
          "subscription.dialog.cancel.consequences.access_loss":
            "Całkowita utrata dostępu do aplikacji CARBOwaste",
          "subscription.dialog.cancel.consequences.no_functions":
            "Brak możliwości korzystania z żadnych funkcji aplikacji",
          "subscription.dialog.cancel.consequences.reports_loss":
            "Utrata dostępu do wszystkich raportów i analiz",
          "subscription.dialog.cancel.consequences.support_loss":
            "Utrata dostępu do wsparcia technicznego",
          "subscription.dialog.cancel.consequences.processing_time":
            "Anulowanie zostanie przetworzone przez Microsoft w ciągu 24-48 godzin",
          "subscription.dialog.cancel.support_suggestion":
            "Jeśli masz problemy z aplikacją, skontaktuj się z naszym wsparciem przed anulowaniem subskrypcji.",
          "subscription.danger.title": "Strefa niebezpieczna",
          "subscription.danger.description":
            "Anulowanie subskrypcji jest działaniem nieodwracalnym. Po anulowaniu utracisz dostęp do całej aplikacji CARBOwaste.",
          "subscription.alert.activation_failed":
            "Nie udało się aktywować subskrypcji: {{message}}",
          "subscription.alert.cancellation_success":
            "Subskrypcja została pomyślnie anulowana. ID operacji: {{operationId}}",
          "subscription.actions.cancel": "Anuluj subskrypcję",
          "subscription.dashboard.configure": "Konfiguruj konto",

          // Console log messages for debugging - leave as is for debugging purposes
          // API error codes and debug messages should remain in Polish for consistency

          // Debug messages for UserContext collection points
          debug_setuser_saving_collection_points:
            "💾 setUserInfo: Zapisuję {{count}} collection points do Excel storage",
          debug_collection_points_saved: "✅ Collection points zapisane do Excel storage",
          debug_collection_points_save_error:
            "❌ Błąd zapisywania collection points do Excel storage:",
          debug_loading_collection_points_start: "🔄 Rozpoczynam ładowanie collection points...",
          debug_collection_points_loaded: "✅ Załadowano {{count}} collection points",
          debug_loading_collection_points_end: "🔄 Zakończono ładowanie collection points",

          // Reports error messages - dodatkowe
          "report.error.invalid_parameters_console":
            "Nieprawidłowe parametry dla generowania raportu",

          // Image Viewer Dialog (dialog/image-viewer.html)
          image_viewer_title: "Podgląd obrazu",
          image_viewer_alt: "Podgląd",
          image_viewer_error_load_failed: "Nie udało się załadować obrazu",
          image_viewer_error_no_url: "Brak adresu obrazu",
          image_viewer_error_general: "Wystąpił błąd podczas ładowania podglądu",
        },
      },
    },
    lng: "pl", // Język polski jako jedyny obsługiwany
    fallbackLng: "pl", // Polski jako fallback
    interpolation: { escapeValue: false },
  })
  .then(() => {
    // eslint-disable-next-line no-undef
    console.log("✅ i18n initialization completed successfully");
  })
  .catch((error) => {
    // eslint-disable-next-line no-undef
    console.error("❌ i18n initialization failed:", error);
  });
export default i18n;
